import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { Props } from "./types";
import { ToggleArrow } from "./toggleArrow";
import styles from "./styles.scss";

function ProjectReportSelect(props: Props) {
  const { t } = useTranslation();

  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div
          className={classNames(styles.projectReportSelect, {
            [styles.open]: isVisible,
          })}
        >
          <div
            className={styles.input}
            onClick={(e) => {
              (isVisible ? hide : show)();
            }}
          >
            {props.selectedProjectReport ? (
              <p className={styles.selectedReport}>
                {props.selectedProjectReport.name}
              </p>
            ) : (
              <p>
                {t(
                  "projectPage.synthesisPage.pdfExport.form.reportPlaceholder",
                )}
              </p>
            )}
            <ToggleArrow className={styles.toggleIcon} />
          </div>
          {isVisible && (
            <div className={styles.list}>
              {props.reports.map((report) => (
                <div
                  key={report.uuid}
                  className={styles.projectReport}
                  onClick={() => {
                    props.selectProjectReport(
                      props.selectedProjectReport &&
                        report.uuid === props.selectedProjectReport.uuid
                        ? undefined
                        : report,
                    );
                    hide();
                  }}
                >
                  <p className={styles.selectedReport}>{report.name}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { ProjectReportSelect };
